import React, { useEffect, useState } from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Organism1 from "./Organism1";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import DfpAd from "../../dfp-ad";

import { getSlug, getCollectionName } from "../../utils/utils";

import "./tenStories2AdWithLoadMore.m.css";

const TenStories2AdWithLoadMore = ({ collection, sections, domainSlug, lang }) => {
  const [isMobile, setIsMobile] = useState(false);
  if (!(collection && collection.items && collection.items.length)) {
    return null;
  }

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const adSlotId1 = get(collection, ["associated-metadata", "ad_slot_id1"], "default_ad_slot1");
  const adSlotId2 = get(collection, ["associated-metadata", "ad_slot_id2"], "default_ad_slot2");
  const adSlotId3 = get(collection, ["associated-metadata", "ad_slot_id3"], "default_ad_slot3");

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(!isMobile);
  }, []);

  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);

  return (
    <div styleName="base">
      {showCollectionName && (
        <CollectionTitleWithArrow collectionName={collectionName} collectionSlug={collectionSlug} />
      )}
      <div styleName="wrapper">
        <div styleName="empty-div" />
        <Organism1 collection={collection} adSlotId1={adSlotId1} adSlotId2={adSlotId2} lang={lang} />
        <div styleName="ad-slot">
          <DfpAd adtype={lang === "en" ? "EnPalo_ROS_300x250_R2" : "News_336x280_R2"} slotId={adSlotId3} />
        </div>
      </div>
    </div>
  );
};

TenStories2AdWithLoadMore.propTypes = {
  collection: object,
  sections: array,
  domainSlug: string,
  lang: string,
};

TenStories2AdWithLoadMore.storyLimit = 10;

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(TenStories2AdWithLoadMore);
